import React from 'react';
import CardPlanPriceCoverage, {
  OptionalCoverageItem,
} from '@components/card/CardPlanPriceCoverage';
import REText from '@components/wrappedBDS/REText';
import {
  CoverageSelectionHandler,
  PLANS_AND_PRICES_LABELS,
} from '@templates/misc/PlansAndPricesTemplate';

type ProductAddOnOldProps = {
  optionalCoverages: OptionalCoverageItem[];
  selectedCoverages: OptionalCoverageItem[];
  onCoverageSelection: CoverageSelectionHandler;
};

const ProductAddOnOld: React.FC<ProductAddOnOldProps> = (props) => {
  return (
    <div id="plans-optional-coverages">
      <REText variant="heading-04" className="mt-5" color="primary">
        {PLANS_AND_PRICES_LABELS.COVERAGE_SELECTION_HEADER}
      </REText>
      <div id="coverages-container">
        <div className="space-y-5 my-3">
          {props.optionalCoverages.map((cvg) => (
            <CardPlanPriceCoverage
              key={cvg.id}
              id={cvg.id}
              name={cvg.name}
              subtext={cvg.subtext}
              icon={cvg.icon}
              price={cvg.price}
              selected={!!props.selectedCoverages.find((s) => s.id === cvg.id)}
              onSelect={() => props.onCoverageSelection(cvg)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductAddOnOld;
